import { createClient } from '@supabase/supabase-js'

// Project credentials from Supabase
const SUPABASE_URL = 'https://yxnhcffechgdovfakwfu.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inl4bmhjZmZlY2hnZG92ZmFrd2Z1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTIzMjEyNzEsImV4cCI6MjA2Nzg5NzI3MX0.TiRT8no-8YRmlow_gcta3JR6oVcuVF-f2NRT0xuxX3Y'

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error('Missing Supabase credentials')
}

console.log('Initializing Supabase client')

const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false,
    storage: window.localStorage
  }
})

export default supabase